<script>
import axios from 'axios';
import RbxFileUpload from '@/shared/reybex/RbxFileUpload';
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxTextEditor from '../../../shared/reybex/RbxTextEditor';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'CompanyBasicInfoForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxTextEditor,
    RbxFileUpload,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'company',
      companyLogo: this.company.logo,
    };
  },
  methods: {
    refreshLogo() {
      const self = this;

      axios.get(`/company/show/${this.company.id}`)
        .then((res) => {
          self.companyLogo = res.data.logo;
        });
    },
  },
};
</script>

<template>
  <div class="company-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex xs12 md12>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('company.name')" md4 >
            <v-text-field
              v-model="company.name"
              label="Firma"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex md8>
            <v-layout row wrap>
              <v-flex md3>
                <span style="color: #757575; font-size: 10px important;">Logo</span>
                <RbxFileUpload
                  height="100"
                  domain="Company"
                  :reference-id="company.id"
                  :file-resource="'companyLogo/' + company.id"
                  @uploaded="refreshLogo()"
                  :accepted-types="'image/jpeg, image/jpg, image/png'"
                  :allow-multiple="false"
                />
              </v-flex>
              <v-flex md9>
                <v-img v-if="companyLogo && companyLogo.path && companyLogo.id"
                       :src="companyLogo.path + '?logoId=' + companyLogo.id"
                       :max-height="200"
                       :max-width="200"
                />
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex v-if="isFieldVisible('company.street')" md4 py-0>
            <v-text-field
              v-model="company.street"
              label="Straße"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.zipCode')" md1 py-0>
            <v-text-field
              v-model="company.zipCode"
              label="PLZ"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.city')" md3 py-0>
            <v-text-field
              v-model="company.city"
              label="Ort"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.country')" md4 py-0>
            <v-text-field
              v-model="company.country"
              label="Land"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex md12 py-0>&nbsp;</v-flex>

          <v-flex v-if="isFieldVisible('company.phone')" md4 py-0>
            <v-text-field
              v-model="company.phone"
              label="Telefon"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.mobile')" md4 py-0>
            <v-text-field
              v-model="company.mobile"
              label="Handy"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.fax')" md4 py-0>
            <v-text-field
              v-model="company.fax"
              label="Fax"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.email')" md4 py-0>
            <v-text-field
              v-model="company.email"
              label="E-Mail-Adresse"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.web')" md4 py-0>
            <v-text-field
              v-model="company.web"
              label="Webseite"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex md12 py-0>&nbsp;</v-flex>

          <v-flex v-if="isFieldVisible('company.chiefResponsibleJob')" md6 py-0>
            <v-text-field
              v-model="company.chiefResponsibleJob"
              label="Leiter der verantwortlichen Stelle"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.chiefDataProcessing')" md6 py-0>
            <v-text-field
              v-model="company.chiefDataProcessing"
              label="Leiter der Datenverarbeitung / IT"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex md12 py-0>&nbsp;</v-flex>

          <v-flex xs12 md12 v-if="isFieldVisible('company.profileResponsibleJob')">
            <rbx-text-editor
              label="Kurzprofil der Verantwortlichen Stelle"
              v-model="company.profileResponsibleJob"
            />
          </v-flex>

          <v-flex md4>
            <v-layout row wrap>
              <v-flex md6 py-0>
                <v-switch
                  v-model="company.isActive"
                  label="Aktiv"
                  height="0"
                  :disabled="true"
                />
              </v-flex>
              <v-flex md6 py-0>
                <v-switch
                  v-model="company.isDemo"
                  label="Demo"
                  height="0"
                  :disabled="true"
                />
              </v-flex>
            </v-layout>
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
